import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import AppIcon from '../../../../../../components/AppIcon';

const MarketApp = ({ app, isMobileView, className, onRemoveApp }) => {
  if (isMobileView) {
    return (
      <div onClick={() => onRemoveApp(app)} className={cx('market-app-mobile', className)}>
        <span className="market-app-mobile__remove" />
        <AppIcon
          key={app.ref_no}
          url={app.icon_url}
          store={app.store}
          size={56}
          alt={app.name}
          hideHtmlTitle
          withBorder
        />
      </div>
    );
  }

  return (
    <div className={cx('market-app-desktop', className)}>
      <AppIcon
        key={app.ref_no}
        url={app.icon_url}
        store={app.store}
        size={40}
        alt={app.name}
        containerClasses="market-app-desktop__icon"
        hideHtmlTitle
        withBorder
      />
      <span className="market-app-desktop__name">{app.name}</span>
      <span onClick={() => onRemoveApp(app)} className="market-app-desktop__remove">
        Remove
      </span>
    </div>
  );
};

MarketApp.propTypes = {
  app: T.shape({
    ref_no: T.oneOfType([T.string, T.number]),
    name: T.string,
    store: T.string,
    icon_url: T.string,
  }),
  isMobileView: T.bool.isRequired,
  className: T.string,
  onRemoveApp: T.func.isRequired,
};

export default MarketApp;
